// @generated by protoc-gen-es v2.14.0 with parameter "target=ts"
// @generated from file history.proto (package history.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file history.proto.
 */
export const file_history: GenFile = /*@__PURE__*/
  fileDesc("Cg1oaXN0b3J5LnByb3RvEgpoaXN0b3J5LnYxIp4CChZCdWNrZXRlZEhpc3RvcnlSZXF1ZXN0Eg4KBmVudGl0eRgBIAEoCRIPCgdwcm9qZWN0GAIgASgJEhIKCnJ1bl9maWx0ZXIYAyABKAkSDQoFc3BlY3MYBCADKAkSEgoFbGltaXQYBiABKAVIAIgBARISCgVvcmRlchgHIAEoCUgBiAEBEhQKDGN1cnJlbnRfcnVucxgIIAMoCRIZCgxsYXN0X3VwZGF0ZWQYCSABKAlIAogBARITCgtjb25maWdfa2V5cxgKIAMoCRIUCgxzdW1tYXJ5X2tleXMYCyADKAlCCAoGX2xpbWl0QggKBl9vcmRlckIPCg1fbGFzdF91cGRhdGVkSgQIBRAGUhFwcmltYXJ5X2xpbmVfdHlwZSKDAwoSUnVuQnVja2V0ZWRIaXN0b3J5EhAKCHJ1bl9uYW1lGAEgASgJEhMKC3NwZWNzX2Fycm93GAIgAygMEhIKCmluY29tcGxldGUYAyABKAgSEgoKdXBkYXRlZF9hdBgEIAEoCRIUCgxkaXNwbGF5X25hbWUYBSABKAkSIAoTZGVmYXVsdF9jb2xvcl9pbmRleBgGIAEoBUgAiAEBEhMKBmNvbmZpZxgHIAEoCUgBiAEBEhQKB3N1bW1hcnkYCCABKAlIAogBARISCgpjcmVhdGVkX2F0GAkgASgJEhQKDGhlYXJ0YmVhdF9hdBgKIAEoCRINCgVzdGF0ZRgLIAEoCRIXCgpncm91cF9uYW1lGAwgASgJSAOIAQESEQoEaG9zdBgNIAEoCUgEiAEBEg8KB3N0b3BwZWQYDiABKAhCFgoUX2RlZmF1bHRfY29sb3JfaW5kZXhCCQoHX2NvbmZpZ0IKCghfc3VtbWFyeUINCgtfZ3JvdXBfbmFtZUIHCgVfaG9zdCJWChdCdWNrZXRlZEhpc3RvcnlSZXNwb25zZRIsCgRydW5zGAEgAygLMh4uaGlzdG9yeS52MS5SdW5CdWNrZXRlZEhpc3RvcnkSDQoFb3JkZXIYAiADKAkiUAoUQnVja2V0ZWRIaXN0b3J5Q2h1bmsSEAoIcnVuX25hbWUYASABKAkSEgoKc3BlY19pbmRleBgCIAEoDRISCgpzcGVjX2Fycm93GAMgASgMMtABCg5IaXN0b3J5U2VydmljZRJdChJHZXRCdWNrZXRlZEhpc3RvcnkSIi5oaXN0b3J5LnYxLkJ1Y2tldGVkSGlzdG9yeVJlcXVlc3QaIy5oaXN0b3J5LnYxLkJ1Y2tldGVkSGlzdG9yeVJlc3BvbnNlEl8KFVN0cmVhbUJ1Y2tldGVkSGlzdG9yeRIiLmhpc3RvcnkudjEuQnVja2V0ZWRIaXN0b3J5UmVxdWVzdBogLmhpc3RvcnkudjEuQnVja2V0ZWRIaXN0b3J5Q2h1bmswAUI0WjJnaXRodWIuY29tL3dhbmRiL2NvcmUvc2VydmljZXMvZ29yaWxsYS9hcGkvaGlzdG9yeWIGcHJvdG8z");

/**
 * @generated from message history.v1.BucketedHistoryRequest
 */
export type BucketedHistoryRequest = Message<"history.v1.BucketedHistoryRequest"> & {
  /**
   * @generated from field: string entity = 1;
   */
  entity: string;

  /**
   * @generated from field: string project = 2;
   */
  project: string;

  /**
   * @generated from field: string run_filter = 3;
   */
  runFilter: string;

  /**
   * @generated from field: repeated string specs = 4;
   */
  specs: string[];

  /**
   * @generated from field: optional int32 limit = 6;
   */
  limit?: number | undefined;

  /**
   * @generated from field: optional string order = 7;
   */
  order?: string | undefined;

  /**
   * @generated from field: repeated string current_runs = 8;
   */
  currentRuns: string[];

  /**
   * @generated from field: optional string last_updated = 9;
   */
  lastUpdated?: string | undefined;

  /**
   * @generated from field: repeated string config_keys = 10;
   */
  configKeys: string[];

  /**
   * @generated from field: repeated string summary_keys = 11;
   */
  summaryKeys: string[];
};

/**
 * Describes the message history.v1.BucketedHistoryRequest.
 * Use `create(BucketedHistoryRequestSchema)` to create a new message.
 */
export const BucketedHistoryRequestSchema: GenMessage<BucketedHistoryRequest> = /*@__PURE__*/
  messageDesc(file_history, 0);

/**
 * @generated from message history.v1.RunBucketedHistory
 */
export type RunBucketedHistory = Message<"history.v1.RunBucketedHistory"> & {
  /**
   * @generated from field: string run_name = 1;
   */
  runName: string;

  /**
   * @generated from field: repeated bytes specs_arrow = 2;
   */
  specsArrow: Uint8Array[];

  /**
   * @generated from field: bool incomplete = 3;
   */
  incomplete: boolean;

  /**
   * @generated from field: string updated_at = 4;
   */
  updatedAt: string;

  /**
   * @generated from field: string display_name = 5;
   */
  displayName: string;

  /**
   * @generated from field: optional int32 default_color_index = 6;
   */
  defaultColorIndex?: number | undefined;

  /**
   * @generated from field: optional string config = 7;
   */
  config?: string | undefined;

  /**
   * @generated from field: optional string summary = 8;
   */
  summary?: string | undefined;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string heartbeat_at = 10;
   */
  heartbeatAt: string;

  /**
   * @generated from field: string state = 11;
   */
  state: string;

  /**
   * @generated from field: optional string group_name = 12;
   */
  groupName?: string | undefined;

  /**
   * @generated from field: optional string host = 13;
   */
  host?: string | undefined;

  /**
   * @generated from field: bool stopped = 14;
   */
  stopped: boolean;
};

/**
 * Describes the message history.v1.RunBucketedHistory.
 * Use `create(RunBucketedHistorySchema)` to create a new message.
 */
export const RunBucketedHistorySchema: GenMessage<RunBucketedHistory> = /*@__PURE__*/
  messageDesc(file_history, 1);

/**
 * @generated from message history.v1.BucketedHistoryResponse
 */
export type BucketedHistoryResponse = Message<"history.v1.BucketedHistoryResponse"> & {
  /**
   * @generated from field: repeated history.v1.RunBucketedHistory runs = 1;
   */
  runs: RunBucketedHistory[];

  /**
   * @generated from field: repeated string order = 2;
   */
  order: string[];
};

/**
 * Describes the message history.v1.BucketedHistoryResponse.
 * Use `create(BucketedHistoryResponseSchema)` to create a new message.
 */
export const BucketedHistoryResponseSchema: GenMessage<BucketedHistoryResponse> = /*@__PURE__*/
  messageDesc(file_history, 2);

/**
 * @generated from message history.v1.BucketedHistoryChunk
 */
export type BucketedHistoryChunk = Message<"history.v1.BucketedHistoryChunk"> & {
  /**
   * @generated from field: string run_name = 1;
   */
  runName: string;

  /**
   * @generated from field: uint32 spec_index = 2;
   */
  specIndex: number;

  /**
   * @generated from field: bytes spec_arrow = 3;
   */
  specArrow: Uint8Array;
};

/**
 * Describes the message history.v1.BucketedHistoryChunk.
 * Use `create(BucketedHistoryChunkSchema)` to create a new message.
 */
export const BucketedHistoryChunkSchema: GenMessage<BucketedHistoryChunk> = /*@__PURE__*/
  messageDesc(file_history, 3);

/**
 * @generated from service history.v1.HistoryService
 */
export const HistoryService: GenService<{
  /**
   * @generated from rpc history.v1.HistoryService.GetBucketedHistory
   */
  getBucketedHistory: {
    methodKind: "unary";
    input: typeof BucketedHistoryRequestSchema;
    output: typeof BucketedHistoryResponseSchema;
  },
  /**
   * @generated from rpc history.v1.HistoryService.StreamBucketedHistory
   */
  streamBucketedHistory: {
    methodKind: "server_streaming";
    input: typeof BucketedHistoryRequestSchema;
    output: typeof BucketedHistoryChunkSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_history, 0);

